// (C) Copyright 2020 CNCC Services <https://www.cncc.fr/>
// This program is the sole property of CNCC Services and is not free software.

import { ValidatorResult } from "../ui/types/Types";

export const validate = (emails: string[]): ValidatorResult => {
  const result: ValidatorResult = {
    validate: true,
    message: ""
  };
  if (emails.length === 0) {
    result.validate = false;
    result.message = "broadcast_list.submit.error.no_emails";
  } else if (
    emails.length > 0 &&
    emails.find(sub => !/^.+@.+\..+$/.test(sub))
  ) {
    result.validate = false;
    result.message = "broadcast_list.submit.error.not_an_email";
  }
  return result;
};
